import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const CountingAccordion = () => {
    const [CompanyDtlState] = useCompanyDetailTracked();
    const { countingFrom, countingTo } = CompanyDtlState.companyFspState;
    const companyFSPVM = useCompanyFspVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "14vw" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={countingFrom}
                        fieldValue={countingFrom}
                        fieldLabel={"FSP Counting From"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'countingFrom'}
                        maxLength={60}
                        options={CompanyDtlState.dynamicOptions.fspCountingFromDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            companyFSPVM.onCompanyFSPFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

                <div className='im-flex-row-item' style={{ width: "14vw" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={countingTo}
                        fieldValue={countingTo}
                        fieldLabel={"FSP Counting To"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'countingTo'}
                        maxLength={60}
                        options={CompanyDtlState.dynamicOptions.fspCountingToDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            companyFSPVM.onCompanyFSPFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

            </div>
            {CompanyDtlState.forceRefresh && <></>}
        </>
    )
}